import React, { useEffect, useState } from 'react'
import style from './NavBar.module.css'
import { Link, scroller } from 'react-scroll';
import { List, X } from "@phosphor-icons/react";
import Logo from '../../Assets/icons/logo.svg';

const NavBar = (props) => {
	const [open, setOpen] = useState(false);

	// Close drawer on Escape and lock body scroll when open
	useEffect(() => {
		const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, []);

	useEffect(() => {
		const original = document.body.style.overflow;
		if (open) document.body.style.overflow = 'hidden';
		else document.body.style.overflow = original || '';
		return () => { document.body.style.overflow = original || ''; };
	}, [open]);

	const closeDrawer = () => setOpen(false);
	const toggleDrawer = () => setOpen((v) => !v);

	return (
		<nav className={style.NavBar}>
			<div
				className={style.NavLogo}
				role="button"
				tabIndex={0}
				onClick={() => scroller.scrollTo('home', { smooth: true, offset: -80, duration: 500 })}
				onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') scroller.scrollTo('home', { smooth: true, offset: -80, duration: 500 }); }}
			>
				<img src={Logo} alt="EA Logo" className={style.LogoImage} />
			</div>

			<div className={style.NavItemsContainer}>
				<Link to='home' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Home</Link>
				<Link to='brands' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Brands</Link>
				<Link to='portfolio' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Projects</Link>
				<Link to='media' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Media</Link>
				<Link to='achievements' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Achievements</Link>
				<Link to='contact' className={style.NavItem} activeClass={style.Active} spy={true} smooth={true} offset={-80}>Contact</Link>
			</div>

			<div className={style.RightControls}>
				<button aria-label={open ? 'Close menu' : 'Open menu'} className={style.Hamburger} onClick={toggleDrawer}>
					{open ? <X size={28} color="#b8b8b8" weight="regular" /> : <List size={28} color="#b8b8b8" weight="regular" />}
				</button>
			</div>

			{open && <div className={style.DrawerBackdrop} onClick={closeDrawer} />}
			<div className={`${style.Drawer} ${open ? style.DrawerOpen : ''}`} role="dialog" aria-modal="true">
				<div className={style.DrawerHeader}>
					<span className={style.DrawerTitle}>Menu</span>
					<button aria-label="Close menu" className={style.DrawerClose} onClick={closeDrawer}>
						<X size={24} color="#b8b8b8" />
					</button>
				</div>
				<div className={style.DrawerNav}>
					<Link to='home' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Home</Link>
					<Link to='brands' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Brands</Link>
					<Link to='portfolio' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Projects</Link>
					<Link to='media' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Media</Link>
					<Link to='achievements' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Achievements</Link>
					<Link to='contact' className={style.DrawerLink} activeClass={style.Active} spy={true} smooth={true} offset={-80} onClick={closeDrawer}>Contact</Link>
				</div>
			</div>
		</nav>
	)
};

export default NavBar;